import { render, staticRenderFns } from "./ResolveTicketSidebar.vue?vue&type=template&id=b86aff98"
import script from "./ResolveTicketSidebar.vue?vue&type=script&lang=js"
export * from "./ResolveTicketSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports